import React, { useState, useEffect } from "react";
import Markdown from 'react-markdown';
import "./InsightsTable.css";

function InsightsTable({ subdomain }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (subdomain) {
            setLoading(true);
            setError(null);
            async function fetchData() {
                try {
                    const response = await fetch(`https://adbot.nw18.com/api/campaign-logs?SUB-DOMAIN=${subdomain}`);
                    if (!response.ok) {
                        throw new Error(`Network response was not ok: ${response.statusText}`);
                    }
                    const result = await response.json();
                    setData(result.data || []); 
                } catch (error) {
                    setError(error.message);
                } finally {
                    setLoading(false);
                }
            }

            fetchData();
        }
    }, [subdomain]);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <section className="insights">
            {loading ? (
                <p>Loading data...</p>
            ) : error ? (
                <p className="error">Error: {error}</p>
            ) : data.length > 0 ? (
                <table className="insights-table">
                    <thead>
                        <tr>
                            <th>Domain</th>
                            <th>Question</th>
                            <th>Answer</th>
                            <th>Created At</th>
                            <th>Response Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <a 
                                        href={`https://${subdomain}.adbot.nw18.com`} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                    >
                                        {subdomain}
                                    </a>
                                </td>
                                <td>{item.question || " "}</td>
                                <td><Markdown>{item.answer || " "}</Markdown></td>
                                <td>{item.createdAt ? formatDate(item.createdAt) : " "}</td>
                                <td>{item.responseTime || " "}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>No data available for the selected campaign.</p>
            )}
        </section>
    );
}

export default InsightsTable;
